import React, { useState, useMemo } from 'react';
import { Grid } from '@material-ui/core';
import BreadCrumbs from '../../../../Core/Controls/Breadcrumb';
import ReportGijgoGrid from '../../../internal/ReportsScreens/GijgoForReportsScreen';
import { SquareButton } from '../../../../Core/FormInput/AppButton';
import { Add } from '@material-ui/icons';
import EditIcon from '@material-ui/icons/Edit';
import ReactDOM from 'react-dom';
import DialogComp from '../../../../Core/Modal/dialogModal';
import UpdateScheduleEventsModal from './updateScheduleEventsModal';

let styleObj = {
    backgroundColor: '#183B68',
    borderRadius: '20%',
    width: '32px',
    height: '32px',
    textAlign: 'center',
    padding: '0px 0px 0px 0px'
};

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'Schedule Events', path: '/', active: true }
];

const TcardScheduleEvents = () => {
    const [state, setState] = useState({
        isReload: new Date(),
        showModal: false,
        id: null,
        selectedScheduleEvent: null
    });
    const handleClose = (shouldReload) => {
        setState((st) => ({
            ...st,
            showModal: false,
            id: null,
            isReload: shouldReload ? new Date() : st.isReload
        }));
    };

    const baseColumns = [
        {
            field: 'action',
            title: `Action`,
            filterable: false,
            sortable: false,
            width: '2%'
        },
        {
            field: 'eventName',
            title: `Event Name`,
            filterable: true,
            sortable: true,
            width: '10%'
        },
        {
            field: 'eventType',
            title: `Event Type`,
            filterable: true,
            sortable: true,
            width: '10%'
        },
        {
            field: 'workType',
            title: `Work Type`,
            filterable: true,
            sortable: true,
            width: '10%'
        }
        // {
        //     field: 'acmcod',
        //     title: `acmcod`,
        //     filterable: true,
        //     sortable: true,
        //     width: '10%'
        // },
        // {
        //     field: 'acmtlm',
        //     title: `acmtlm`,
        //     filterable: true,
        //     sortable: true,
        //     width: '10%'
        // },
        // {
        //     field: 'acmtlp',
        //     title: `acmtlp`,
        //     filterable: true,
        //     sortable: true,
        //     width: '10%'
        // }
    ];

    const handelAddUpdate = (row = null) => {
        setState((st) => ({
            ...st,
            showModal: true,
            id: row ? row.id : null,
            selectedScheduleEvent: row ? row : null
        }));
    };

    const editButton = () => (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justifyContent="space-evenly">
                <abbr title="Edit Work Type event">
                    {' '}
                    <SquareButton style={styleObj} onClick={() => handelAddUpdate(record)}>
                        <EditIcon fontSize="small" style={{ color: 'white' }} />
                    </SquareButton>
                </abbr>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const columns = useMemo(() => {
        const tempCols = [...baseColumns];
        let actionCol = tempCols.find((element) => element.field === 'action');

        if (actionCol) {
            actionCol.renderer = editButton({});
        }

        return tempCols;
    }, []);

    const renderTitle = (value, record) => {
        return (
            <Grid container justifyContent="space-between" spacing={1}>
                <Grid item xs={12} sm={12}>
                    {'Update Schedule Events'}
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Grid container>
                        <Grid item xs={12} style={{ fontSize: 14 }}>{`Event Name`}</Grid>
                        <Grid item style={{ fontSize: 14, fontWeight: 'bold' }}>{`${state.selectedScheduleEvent?.eventName || ''}`}</Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Grid container>
                        <Grid item xs={12} style={{ fontSize: 14 }}>{`Event Type`}</Grid>
                        <Grid item xs style={{ fontSize: 14, fontWeight: 'bold' }}>{`${state.selectedScheduleEvent?.eventType || ''}`}</Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    const baseUrl = 'TCardScheduleEvents/TCardScheduleEvents_List';

    return (
        <div>
            <BreadCrumbs crumbs={crumbs} />
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <ReportGijgoGrid
                        dataConverter={(res) => ({
                            records: res?.data,
                            total: res?.data[0]?.total
                        })}
                        columns={columns}
                        getUrl={baseUrl}
                        isReload={state.isReload}
                    />
                </Grid>
            </Grid>
            {state.showModal ? (
                <DialogComp maxWidth="lg" overflow="auto" title={renderTitle()} onClose={() => handleClose(false)}>
                    <UpdateScheduleEventsModal onClose={() => handleClose(true)} id={state.id} />
                </DialogComp>
            ) : null}
        </div>
    );
};
export default TcardScheduleEvents;
